module.exports = __webpack_public_path__ + "media/images/flags/4x3/wsm-17e330de6578c1e9b404039628faecae.svg";